import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Transportista/deleteSeleccionTransporte`, method: 'POST', body: {list}, token: token})
}